import { BadgeCheck, Home, Wallet, Landmark } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "El viento que da nombre",
    text: "Ehécatl, el dios mexica del viento, mueve lo invisible y lo transforma todo. Ese mismo espíritu recorre cada nivel de este condominio: aire, luz y movimiento en el corazón de San Cristóbal Centro.",
  },
  {
    num: "02",
    title: "Solo 28 familias",
    text: "No es un desarrollo masivo: son 28 departamentos exclusivos. La escala justa para convivir, la privacidad que tu familia merece y una plusvalía que crece en una de las zonas con mayor proyección de Ecatepec.",
  },
];

const STATS = [
  { n: "28", l: "Departamentos exclusivos" },
  { n: "7+PB", l: "Niveles · PB es estacionamiento y acceso" },
  { n: "164 m²", l: "Roof garden común" },
  { n: "25", l: "Años de PRODECOM" },
];

const POINTS = [
  { icon: BadgeCheck, title: "25 años cimentando el futuro", text: "PRODECOM cumple 25 aniversario desarrollando proyectos habitacionales de alta plusvalía en el Estado de México." },
  { icon: Home, title: "Entrega con acabados premium", text: "Cocina equipada, walking closet, sanitarios de alta gama y ventanales de aluminio negro. Listo para estrenar." },
  { icon: Wallet, title: "Financiamiento a tu medida", text: "Nuestro equipo te acompañará en todo el proceso." },
];

export default function Manifesto() {
  return (
    <section id="manifiesto" data-testid="manifesto-section" className="relative py-24 sm:py-32 lg:py-36 bg-[#f4f2ea]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          eyebrow="Manifiesto"
          light
          title={<>Un condominio que nace<br />del <span className="text-[#bfa360] italic">viento</span></>}
        />

        <div className="mt-14 sm:mt-20 grid sm:grid-cols-2 gap-12 lg:gap-16">
          {CHAPTERS.map((c, i) => (
            <div key={c.num}>
              <Reveal>
                <span className="font-display lnum text-6xl sm:text-7xl text-[#bfa360]">{c.num}</span>
              </Reveal>
              <Reveal delay={0.1}>
                <h3 className="font-display text-3xl sm:text-4xl text-[#1c242f] mt-4 mb-4">{c.title}</h3>
              </Reveal>
              <Reveal delay={0.18}>
                <p className="text-[#5c6657] leading-relaxed text-base sm:text-lg">{c.text}</p>
              </Reveal>
            </div>
          ))}
        </div>

        <div className="mt-16 sm:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#1c242f]/10 rounded-2xl overflow-hidden">
          {STATS.map((s, i) => (
            <Reveal key={s.l} delay={i * 0.08} className="bg-[#faf8f1] p-8 sm:p-10" y={20}>
              <p data-testid={`stat-${i}`} className="font-display lnum text-5xl sm:text-6xl text-[#bfa360]">{s.n}</p>
              <p className="mt-3 mono text-[10px] sm:text-[11px] uppercase tracking-[0.22em] text-[#5c6657]">{s.l}</p>
            </Reveal>
          ))}
        </div>

        {/* Respaldo PRODECOM */}
        <div className="mt-20 sm:mt-24 pt-14 border-t border-[#1c242f]/10">
          <div className="grid lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-4">
              <Reveal>
                <p className="mono text-[11px] uppercase tracking-[0.3em] text-[#bfa360] mb-4">El respaldo</p>
                <p className="font-display text-5xl sm:text-6xl text-[#1c242f] leading-none">PRODE<span className="text-[#bfa360] italic">COM</span></p>
                <p className="mt-3 mono text-[11px] uppercase tracking-[0.3em] text-[#5c6657]">Cimentando el futuro · 25 aniversario</p>
              </Reveal>
            </div>
            <div className="lg:col-span-8 grid sm:grid-cols-3 gap-5">
              {POINTS.map((p, i) => (
                <Reveal key={p.title} delay={i * 0.08} y={22}>
                  <div className="h-full rounded-2xl border border-[#1c242f]/10 bg-white p-7 shadow-sm hover:border-[#bfa360]/60 transition-colors duration-500">
                    <p.icon size={22} className="text-[#bfa360] mb-5" />
                    <h3 className="font-display text-xl text-[#1c242f] mb-3 leading-snug">{p.title}</h3>
                    <p className="text-sm text-[#5c6657] leading-relaxed">{p.text}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
          <Reveal delay={0.15}>
            <div className="mt-10 flex items-center gap-4 text-[#5c6657]">
              <Landmark size={15} className="text-[#bfa360]" />
              <p className="mono text-[10px] sm:text-[11px] uppercase tracking-[0.22em]">
                Información de carácter informativo, puede cambiar sin previo aviso.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
